/**
 * Filter State Manager
 * Updates "All Filters" button count and syncs states after filter changes
 */
class FilterStateManager {
    constructor() {
        this.updateTimeout = null;
        this.init();
    }

    init() {
        document.addEventListener('facets:updated', () => {
            clearTimeout(this.updateTimeout);
            this.updateTimeout = setTimeout(() => {
                this.updateAfterFilterChange();
            }, 350);
        });

        setTimeout(() => this.updateAfterFilterChange(), 200);
    }

    updateAfterFilterChange() {
        this.updateAllFiltersButtonCount();
        this.syncDisabledStates();
        this.refreshDropdowns();
    }

    /**
     * Update "All Filters" button count from URL (unique filters only)
     */
    updateAllFiltersButtonCount() {
        const span = document.getElementById('active-filter-count');
        if (!span) return;

        const params = new URLSearchParams(window.location.search);

        const uniqueFilters = new Set();

        for (const [key, value] of params.entries()) {
            if (key.startsWith('filter.')) {
                uniqueFilters.add(`${key}=${value}`);
            }
        }

        const count = uniqueFilters.size;

        span.textContent = count > 0 ? `(${count})` : '';
    }

    /**
     * Sync disabled states based on product counts from DOM
     */
    syncDisabledStates() {
        const allCheckboxes = document.querySelectorAll(
            '.facet-checkbox, .filter-checkbox'
        );

        allCheckboxes.forEach(checkbox => {
            const label = checkbox.closest('label, .facet-option-label, .filter-option');
            if (!label) return;

            const countElement = label.querySelector('.facet-option-count, .filter-count, .facet-count');

            if (countElement) {
                const countText = countElement.textContent.trim();
                const match = countText.match(/\((\d+)\)/);
                const count = match ? parseInt(match[1]) : 0;

                const shouldBeDisabled = count === 0 && !checkbox.checked;

                checkbox.disabled = shouldBeDisabled;

                if (shouldBeDisabled) {
                    label.classList.add('disabled');
                } else {
                    label.classList.remove('disabled');
                }
            } else {
                checkbox.disabled = false;
                label.classList.remove('disabled');
            }
        });
    }

    /**
     * Refresh dropdown instances
     */
    refreshDropdowns() {
        if (window.facetDropdownsInstance?.refresh) {
            window.facetDropdownsInstance.refresh();
        }
    }
}

/**
 * Initialize Filter State Manager
 */
let filterStateManager = null;

function initFilterStateManager() {
    if (filterStateManager) return;

    filterStateManager = new FilterStateManager();
    window.filterStateManager = filterStateManager;
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterStateManager);
} else {
    initFilterStateManager();
}

document.addEventListener('shopify:section:load', () => {
    setTimeout(initFilterStateManager, 100);
});